import { DANGER_RED } from './DangerZonePanel';
import type { WorkshopChip } from './workshopsCalendarTypes';

export const CANCELLED_TINT = 'rgba(192,57,43,.12)';
export const CANCELLED_COLOR = DANGER_RED;

export function isCancelled(w: Pick<WorkshopChip, 'lifecycle'>): boolean {
  return w.lifecycle === 'cancelled';
}

export function withoutCancelled<T extends Pick<WorkshopChip, 'lifecycle'>>(workshops: T[]): T[] {
  return workshops.filter((w) => !isCancelled(w));
}
